<app-loader></app-loader>

<div class="container-fluid">
  <app-page-title
    title="Dashboard"
    [breadcrumbItems]="breadCrumbItems"></app-page-title>

  <div class="row">
    <div class="col-xl-8">
      <div class="row">
        <div class="col-lg-4">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="mr-3">
                  <p class="text-muted mb-2">Interviews</p>
                  <h5 class="mb-0">120</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div
                    class="avatar-title bg-light rounded-circle text-primary font-size-20">
                    <i class="bx bxs-book-bookmark"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Photos</p>
                  <h5 class="mb-0">86</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div
                    class="avatar-title bg-light rounded-circle text-primary font-size-20">
                    <i class="bx bxs-note"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="mr-3">
                  <p class="text-muted mb-2">Comments</p>
                  <h5 class="mb-0">4,235</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div
                    class="avatar-title bg-light rounded-circle text-primary font-size-20">
                    <i class="bx bxs-message-square-dots"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap">
            <h5 class="card-title me-2">Residents</h5>
            <div class="ms-auto">
              <div class="toolbar button-items text-end">
                <button
                  type="button"
                  class="btn btn-light btn-sm"
                  (click)="updateOptions('all')"
                  [class.active]="activeOptionButton === 'all'">
                  ALL
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm"
                  (click)="updateOptions('1m')"
                  [class.active]="activeOptionButton === '1m'">
                  1M
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm"
                  (click)="updateOptions('6m')"
                  [class.active]="activeOptionButton === '6m'">
                  6M
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm active"
                  (click)="updateOptions('1y')"
                  [class.active]="activeOptionButton === '1y'">
                  1Y
                </button>
              </div>
            </div>
          </div>

          <div class="row text-center">
            <div class="col-lg-4">
              <div class="mt-4">
                <p class="text-muted mb-1">Today</p>
                <h5>1024</h5>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="mt-4">
                <p class="text-muted mb-1">This Month</p>
                <h5>
                  12356
                  <span class="text-success font-size-13"
                    >0.2 % <i class="mdi mdi-arrow-up ms-1"></i
                  ></span>
                </h5>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="mt-4">
                <p class="text-muted mb-1">This Year</p>
                <h5>
                  102354
                  <span class="text-success font-size-13"
                    >0.1 % <i class="mdi mdi-arrow-up ms-1"></i
                  ></span>
                </h5>
              </div>
            </div>
          </div>

          <hr class="mb-4" />

          <apx-chart
            dir="ltr"
            #chart
            class="apex-charts"
            [chart]="visitorsOptions.chart"
            [series]="visitorsOptions.series"
            [legend]="visitorsOptions.legend"
            [colors]="visitorsOptions.colors"
            [fill]="visitorsOptions.fill"
            [dataLabels]="visitorsOptions.dataLabels"
            [xaxis]="visitorsOptions.xaxis"
            [stroke]="visitorsOptions.stroke">
          </apx-chart>
        </div>
      </div>
    </div>

    <div class="col-xl-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap">
            <h5 class="card-title mb-3 me-2">Residents</h5>

            <div class="dropdown ms-auto" ngbDropdown>
              <a
                class="text-muted dropdown-toggle font-size-16"
                ngbDropdownToggle
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true">
                <i class="mdi mdi-dots-horizontal"></i>
              </a>

              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a ngbDropdownItem href="javascript: void(0);">Action</a>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Another action</a
                >
                <a ngbDropdownItem href="javascript: void(0);"
                  >Something else here</a
                >
                <div class="dropdown-divider"></div>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Separated link</a
                >
              </div>
            </div>
          </div>

          <div class="d-flex flex-wrap">
            <div>
              <p class="text-muted mb-1">Total Subscribe</p>
              <h4 class="mb-3">10,512</h4>
              <p class="text-success mb-0">
                <span>0.6 % <i class="mdi mdi-arrow-top-right ms-1"></i></span>
              </p>
            </div>
            <div class="ms-auto align-self-end">
              <i class="bx bx-group display-4 text-light"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap">
            <div class="me-2">
              <h5 class="card-title mb-3">Top Residents</h5>
            </div>
            <div class="dropdown ms-auto" ngbDropdown>
              <a
                class="text-muted dropdown-toggle font-size-16"
                ngbDropdownToggle
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true">
                <i class="mdi mdi-dots-horizontal"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a ngbDropdownItem href="javascript: void(0);">Action</a>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Another action</a
                >
                <a ngbDropdownItem href="javascript: void(0);"
                  >Something else here</a
                >
                <div class="dropdown-divider"></div>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Separated link</a
                >
              </div>
            </div>
          </div>
          <div class="row text-center">
            <div class="col-6">
              <div class="mt-3">
                <p class="text-muted mb-1">Today</p>
                <h5>1024</h5>
              </div>
            </div>

            <div class="col-6">
              <div class="mt-3">
                <p class="text-muted mb-1">This Month</p>
                <h5>
                  12356
                  <span class="text-success font-size-13"
                    >0.2 % <i class="mdi mdi-arrow-up ms-1"></i
                  ></span>
                </h5>
              </div>
            </div>
          </div>

          <hr />

          <div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <div class="py-2">
                  <h5 class="font-size-14">
                    Resident 1
                    <span class="float-end">78%</span>
                  </h5>
                  <div class="progress animated-progess progress-sm">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      style="width: 78%"
                      aria-valuenow="78"
                      aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="py-2">
                  <h5 class="font-size-14">
                    Resident 2
                    <span class="float-end">69%</span>
                  </h5>
                  <div class="progress animated-progess progress-sm">
                    <div
                      class="progress-bar bg-warning"
                      role="progressbar"
                      style="width: 69%"
                      aria-valuenow="69"
                      aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="py-2">
                  <h5 class="font-size-14">
                    Resident 3
                    <span class="float-end">61%</span>
                  </h5>
                  <div class="progress animated-progess progress-sm">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      style="width: 61%"
                      aria-valuenow="61"
                      aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex">
            <div class="me-2">
              <h5 class="card-title mb-4">Activity</h5>
            </div>
            <div class="dropdown ms-auto" ngbDropdown>
              <a
                class="text-muted dropdown-toggle font-size-16"
                ngbDropdownToggle
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true">
                <i class="mdi mdi-dots-horizontal"></i>
              </a>

              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a ngbDropdownItem href="javascript: void(0);">Action</a>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Another action</a
                >
                <a ngbDropdownItem href="javascript: void(0);"
                  >Something else here</a
                >
                <div class="dropdown-divider"></div>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Separated link</a
                >
              </div>
            </div>
          </div>
          <app-ngx-simplebar style="height: 280px">
            <ul class="verti-timeline list-unstyled">
              <li class="event-list active">
                <div class="event-timeline-dot">
                  <i
                    class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                </div>
                <div class="media">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      10 Nov
                      <i
                        class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="media-body">
                    <div>
                      Posted
                      <span class="fw-semibold"
                        >Beautiful Day with Friends</span
                      >
                      blog... <a href="javascript: void(0);">View</a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="media">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      08 Nov
                      <i
                        class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="media-body">
                    <div>
                      If several languages coalesce, the grammar of the
                      resulting... <a href="javascript: void(0);">Read</a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="media">
                  <div class="mr-3">
                    <h5 class="font-size-14">
                      02 Nov
                      <i
                        class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="media-body">
                    <div>
                      Create
                      <span class="fw-semibold">Drawing a sketch blog</span>
                    </div>
                  </div>
                </div>
              </li>
              <li class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="media">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      24 Oct
                      <i
                        class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="media-body">
                    <div>
                      In enim justo, rhoncus ut, imperdiet a venenatis vitae
                    </div>
                  </div>
                </div>
              </li>
              <li class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="media">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      21 Oct
                      <i
                        class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="media-body">
                    <div>
                      Nemo enim ipsam voluptatem quia voluptas sit aspernatur
                      aut
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </app-ngx-simplebar>

          <div class="text-center mt-4">
            <a href="" class="btn btn-primary waves-effect waves-light btn-sm"
              >View More <i class="mdi mdi-arrow-right ms-1"></i
            ></a>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
    <div class="col-xl-8">
      <div class="card">
        <div class="card-body">
          <div class="d-flex">
            <div class="me-2">
              <h5 class="card-title mb-4">Popular stories</h5>
            </div>
            <div class="dropdown ms-auto" ngbDropdown>
              <a
                class="text-muted dropdown-toggle font-size-16"
                ngbDropdownToggle
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true">
                <i class="mdi mdi-dots-horizontal"></i>
              </a>

              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a ngbDropdownItem href="javascript: void(0);">Action</a>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Another action</a
                >
                <a ngbDropdownItem href="javascript: void(0);"
                  >Something else here</a
                >
                <div class="dropdown-divider"></div>
                <a ngbDropdownItem href="javascript: void(0);"
                  >Separated link</a
                >
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th scope="col" colspan="2">Story</th>
                  <th scope="col">Likes</th>
                  <th scope="col">Comments</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of popularPostData">
                  <td style="width: 100px">
                    <img
                      src="{{ item.image }}"
                      alt=""
                      class="avatar-md h-auto d-block rounded" />
                  </td>
                  <td>
                    <h5 class="font-size-13 text-truncate mb-1">
                      <a href="javascript: void(0);" class="text-dark">{{
                        item.title
                      }}</a>
                    </h5>
                    <p class="text-muted mb-0">{{ item.date }}</p>
                  </td>
                  <td>
                    <i class="bx bx-like align-middle me-1"></i>
                    {{ item.likes }}
                  </td>
                  <td>
                    <i class="bx bx-comment-dots align-middle me-1"></i>
                    {{ item.comments }}
                  </td>
                  <td>
                    <div class="dropdown" ngbDropdown>
                      <a
                        class="text-muted dropdown-toggle font-size-16"
                        ngbDropdownToggle
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true">
                        <i class="mdi mdi-dots-horizontal"></i>
                      </a>

                      <div
                        class="dropdown-menu dropdown-menu-end"
                        ngbDropdownMenu>
                        <a ngbDropdownItem href="javascript: void(0);"
                          >Action</a
                        >
                        <a ngbDropdownItem href="javascript: void(0);"
                          >Another action</a
                        >
                        <a ngbDropdownItem href="javascript: void(0);"
                          >Something else here</a
                        >
                        <div class="dropdown-divider"></div>
                        <a ngbDropdownItem href="javascript: void(0);"
                          >Separated link</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </div>
  <!-- end row -->
</div>

<ng-template #dropdown>
  <div class="dropdown ms-2" ngbDropdown>
    <a
      class="text-muted dropdown-toggle font-size-14"
      ngbDropdownToggle
      href="javascript: void(0);"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <i class="mdi mdi-dots-horizontal"></i>
    </a>

    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
      <a ngbDropdownItem href="javascript:void(0);">Action</a>
      <a ngbDropdownItem href="javascript:void(0);">Another action</a>
      <a ngbDropdownItem href="javascript: void(0);">Something else here</a>
    </div>
  </div>
</ng-template>
